import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import FinanceReportList from './FinanceReportList/FinanceReportList.container';

const FinanceReportPage = ({ t }) => {
    const staticNames = t?.financeReportPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content statistics finance-report">
                <div className="ibox">
                    <FinanceReportList />
                </div>
            </section>
        </React.Fragment>
    );
};

FinanceReportPage.propTypes = {
    t: PropTypes.object
};

FinanceReportPage.defaultProps = {
    t: {}
};

export default withTranslation(FinanceReportPage);
